import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import appStoreLogo from '../assets/app_store_logo.svg';
import playStoreLogo from '../assets/play_store_logo.svg';

const Footer = () => {
  const iosStoreUrl = process.env.REACT_APP_IOS_STORE_URL || 'https://apps.apple.com/';
  const androidStoreUrl = process.env.REACT_APP_ANDROID_STORE_URL || 'https://play.google.com/store';
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">OuiGoo by Ozinex</h3>
            {/* <p className="text-gray-400">+13072857026</p> */}
            {/* <p className="text-gray-400">Solution de livraison dédiée aux e-commerçants et entreprises en Afrique.</p> */}
          </div>
          <div>
            <h4 className="font-semibold mb-4">Liens rapides</h4>
            <ul className="space-y-2">
              <li><a href="/tracking" className="hover:text-primary-custom transition-colors">Suivi</a></li>
              <li><a href="https://ouigoo.gitbook.io/ouigoo" className="hover:text-primary-custom transition-colors">Documentation API</a></li>
              <li><a href="/become-partner" className="hover:text-primary-custom transition-colors">Devenir Partenaire</a></li>
              <li><a href="#a-propos" className="hover:text-primary-custom transition-colors">À propos</a></li>
              <li><a href="/contact" className="hover:text-primary-custom transition-colors">Contact</a></li>
              <li><a href="/privacy-policy" className="hover:text-primary-custom transition-colors">Politique de confidentialité</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Réseaux sociaux</h4>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/ouigoo.co" target="_blank" className="text-gray-400 hover:text-white transition-colors"><FaFacebookF /></a>
              {/* <a href="#twitter" className="text-gray-400 hover:text-white transition-colors"><FaTwitter /></a> */}
              <a href="https://www.instagram.com/ouigoo.co" target="_blank" className="text-gray-400 hover:text-white transition-colors"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/ouigoo" className="text-gray-400 hover:text-white transition-colors"><FaLinkedinIn /></a>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Télécharger l'app</h4>
            <div className="flex flex-row space-x-3">
            <a href={iosStoreUrl} target="_blank" rel="noreferrer" className="inline-block">
                <img src={appStoreLogo} alt="App Store" className="h-10" />
              </a>
              <a href={androidStoreUrl} target="_blank" rel="noreferrer" className="inline-block">
                <img src={playStoreLogo} alt="Google Play" className="h-10" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 text-center text-gray-400">
          <p>&copy; 2026 OuiGoo by Ozinex. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

